import { sessionStoreGet, STORE_KEY_AUTH } from 'mailup-react-helpers'

export const feTracingApiTraceMessage = async payload => {
  await fetch(`${process.env.FETRACING_URL}/api/trace`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${sessionStoreGet(STORE_KEY_AUTH)}`
    },
    body: JSON.stringify(payload)
  })
}
